import React, { useEffect, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import { Link } from "react-router-dom";
import "chart.js/auto";
import {
  getpastperformaceCashdata,
  getpastperformacebymonth,
} from "../../../Services/UserService/User";
import Content from "../../../components/Contents/Content";
import Table from "../../../Extracomponents/Table";
import { fDateTime } from "../../../../Utils/Date_formate";
import { Tooltip } from "antd";
import { Eye, ArrowDownToLine, IndianRupee } from "lucide-react";
import ReusableModal from "../../../components/Models/ReusableModal";

const Cash = () => {
  const token = localStorage.getItem("token");
  const [cashPastData, setCashPastdata] = useState(new Array(12).fill(0));
  const [monthaverg, setMonthaverg] = useState({});

  const today = new Date();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");
  const currentYear = today.getFullYear();

  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [chartData1, setChartData1] = useState(null);
  const [doughnutData1, setDoughnutData1] = useState(null);
  const [dailydata, setDailydata] = useState([]);
  const [description, setDescription] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [cashChartData, setCashChartData] = useState(null);
  const [futureAvgProfit, setFutureAvgProfit] = useState(0);
  const [oneMonth, setOneMonth] = useState(0);
  const [doughnutOptions, setDoughnutOptions] = useState({});

  const months = [
    { name: "Jan", value: "01" },
    { name: "Feb", value: "02" },
    { name: "Mar", value: "03" },
    { name: "Apr", value: "04" },
    { name: "May", value: "05" },
    { name: "Jun", value: "06" },
    { name: "Jul", value: "07" },
    { name: "Aug", value: "08" },
    { name: "Sep", value: "09" },
    { name: "Oct", value: "10" },
    { name: "Nov", value: "11" },
    { name: "Dec", value: "12" },
  ];

  useEffect(() => {
    getCashpastdata();
  }, []);

  // const getCashpastdata = async () => {
  //   try {
  //     const response = await getpastperformaceCashdata(
  //       { id: "66d2c3bebf7e6dc53ed07626" },
  //       token
  //     );

  //     if (response?.status) {
  //       const allDurations = response.data;

  //       // 🔹 1 Month Data
  //       const oneMonthData = allDurations["1_month"];
  //       const monthKey = Object.keys(oneMonthData?.months || {})[0];
  //       const monthData = oneMonthData?.months?.[monthKey] || {};

  //       // Directly use backend-provided netProfitPercentage
  //       const oneMonthPercent = monthData?.netProfitPercentage ?? 0;
  //       setOneMonth(oneMonthPercent);

  //       // 🔹 Last Duration (for future average)
  //       const durationKeys = Object.keys(allDurations);
  //       const lastKey = durationKeys[durationKeys.length - 1] || "";
  //       const lastDuration = allDurations[lastKey];

  //       const lastNetProfitPercentage = lastDuration?.netProfitPercentageaverall ?? 0;
  //       setFutureAvgProfit(lastNetProfitPercentage);

  //       // 🔹 Month-wise data (using backend %)
  //       const months = lastDuration?.months || {};
  //       const monthWiseProfitLoss = {};
  //       const monthWisePercentage = {};

  //       Object.keys(months).forEach((month) => {
  //         const [year, m] = month.split("-");
  //         const monthKey = `${year}-${m.padStart(2, "0")}`;

  //         monthWisePercentage[monthKey] = months[month]?.netProfitPercentage ?? 0;
  //         monthWiseProfitLoss[monthKey] = {
  //           totalProfit: months[month]?.totalProfit ?? 0,
  //           totalLoss: months[month]?.totalLoss ?? 0,
  //         };
  //       });

  //       // 🔹 Sort months
  //       const sortedMonths = Object.keys(monthWisePercentage).sort((a, b) => {
  //         const [yearA, monthA] = a.split("-").map(Number);
  //         const [yearB, monthB] = b.split("-").map(Number);
  //         return yearA - yearB || monthA - monthB;
  //       });

  //       // 🔹 Prepare Chart Data
  //       const chartProfits = sortedMonths.map((month) => {
  //         let value = monthWisePercentage[month] ?? 0;
  //         if (value > 0 && value < 0.5) value = 0.5; // minimal visible bar
  //         return value;
  //       });

  //       const barColors = chartProfits.map((p) =>
  //         p < 0 ? "rgba(236, 34, 19, 0.6)" : "rgba(15, 230, 122, 0.6)"
  //       );

  //       // 🔹 Set Chart Data
  //       setCashChartData({
  //         labels: sortedMonths.map((m) => {
  //           const [year, month] = m.split("-");
  //           return new Date(year, month - 1).toLocaleString("default", {
  //             month: "short",
  //             year: "2-digit",
  //           });
  //         }),
  //         datasets: [
  //           {
  //             label: "Cash Performance/Loss (%)",
  //             data: chartProfits,
  //             backgroundColor: barColors,
  //             tooltipData: sortedMonths.map((m) => monthWiseProfitLoss[m]),
  //           },
  //         ],
  //         options: {
  //           responsive: true,
  //           plugins: {
  //             tooltip: {
  //               callbacks: {
  //                 label: function (context) {
  //                   const month = sortedMonths[context.dataIndex];
  //                   const { totalProfit, totalLoss } = monthWiseProfitLoss[month] || {};
  //                   const value = context.raw.toFixed(2);
  //                   return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}%`;
  //                 },
  //               },
  //             },
  //           },
  //           scales: {
  //             y: {
  //               ticks: {
  //                 callback: function (value) {
  //                   return value.toFixed(2) + "%";
  //                 },
  //               },
  //               min: Math.min(...chartProfits, 0) * 1.2,
  //               max: Math.max(...chartProfits, 0) * 1.2,
  //             },
  //           },
  //         },
  //       });

  //       setCashPastdata(chartProfits);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Cash data:", error);
  //   }
  // };

  // const getPastPerformanceData = async () => {
  //   try {
  //     const data = { id: "66d2c3bebf7e6dc53ed07626", month, year };
  //     const response = await getpastperformacebymonth(data, token);

  //     if (response?.status) {
  //       setDailydata(response?.data);

  //       const signalList = response?.data?.signalList || [];

  //       // 🔹 Group signals by entryDate and sum netGainLossPercent for each day
  //       const dailyNetGainLoss = signalList.reduce((acc, signal) => {
  //         // Convert YYYY-MM-DD -> D-M-YYYY to match dailyData keys
  //         const dateObj = new Date(signal.entryDate);
  //         const date = `${dateObj.getDate()}-${dateObj.getMonth() + 1}-${dateObj.getFullYear()}`;

  //         const percent = parseFloat(signal.netGainLossPercent?.replace("%", "")) || 0;

  //         if (!acc[date]) acc[date] = 0;
  //         acc[date] += percent;

  //         return acc;
  //       }, {});

  //       // Prepare chart data
  //       const dailyDataKeys = Object.keys(response?.data?.dailyData || {}).sort(
  //         (a, b) => new Date(a) - new Date(b)
  //       );

  //       const netProfitData = dailyDataKeys.map(date => dailyNetGainLoss[date] || 0);

  //       const formattedChartData = {
  //         labels: dailyDataKeys,
  //         datasets: [
  //           {
  //             label: "Net Profit (%)",
  //             data: netProfitData,
  //             backgroundColor: netProfitData.map(value =>
  //               value >= 0 ? "rgba(15, 230, 122, 0.6)" : "rgba(236, 34, 19, 0.6)"
  //             ),
  //             borderColor: netProfitData.map(value =>
  //               value >= 0 ? "blue" : "red"
  //             ),
  //             borderWidth: 1,
  //           },
  //         ],
  //       };

  //       setChartData1(formattedChartData);

  //       // Doughnut chart calculation
  //       const calculatedInitialInvestment = signalList.reduce(
  //         (total, signal) => total + (signal.entryPrice || 0),
  //         0
  //       );

  //       const doughnutChartData = {
  //         labels: ["Total Signals", "Profitable Calls", "Loss Calls", "Total Profit (%)", "Total Loss (%)", "Net Profit (%)"],
  //         datasets: [
  //           {
  //             data: [
  //               response?.data?.totalSignals || 0,
  //               response?.data?.profitableCalls || 0,
  //               response?.data?.lossCalls || 0,
  //               response?.data?.totalProfit || 0,
  //               response?.data?.totalLoss || 0,
  //               response?.data?.netProfit || 0,
  //               (() => {
  //                 const totalProfit = response?.data?.totalProfit || 0;
  //                 return calculatedInitialInvestment > 0 ? (totalProfit / calculatedInitialInvestment) * 100 : 0;
  //               })(),
  //               (() => {
  //                 const totalLoss = response?.data?.totalLoss || 0;
  //                 return calculatedInitialInvestment > 0 ? (totalLoss / calculatedInitialInvestment) * 100 : 0;
  //               })(),
  //               (() => {
  //                 const netProfit = response?.data?.netProfit || 0;
  //                 return calculatedInitialInvestment > 0 ? (netProfit / calculatedInitialInvestment) * 100 : 0;
  //               })(),
  //             ],
  //             backgroundColor: ["#36A2EB", "#81ff85ff", "#FF6384", "#0ada3eff", "#FF4444", "#0a5f30ff"],
  //             hoverBackgroundColor: ["#36A2EB", "#81ff85ff", "#FF6384", "#0ada3eff", "#FF4444", "#0a5f30ff"],
  //           },
  //         ],
  //       };

  //       setDoughnutData1(doughnutChartData);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // const getPastPerformanceData = async () => {
  //   try {
  //     const data = { id: "66d2c3bebf7e6dc53ed07626", month, year };
  //     const response = await getpastperformacebymonth(data, token);

  //     if (response?.status) {
  //       setDailydata(response?.data);

  //       const signalList = response?.data?.signalList || [];

  //       // 🔹 Group signals by entryDate and sum netGainLossPercent for each day
  //       const dailyNetGainLoss = signalList.reduce((acc, signal) => {
  //         const dateObj = new Date(signal.entryDate);
  //         const date = `${dateObj.getDate()}-${dateObj.getMonth() + 1}-${dateObj.getFullYear()}`;

  //         const percent = parseFloat(signal.netGainLossPercent?.replace("%", "")) || 0;

  //         if (!acc[date]) acc[date] = 0;
  //         acc[date] += percent;

  //         return acc;
  //       }, {});

  //       // Prepare chart data (Bar/Line chart)
  //       const dailyDataKeys = Object.keys(response?.data?.dailyData || {}).sort(
  //         (a, b) => new Date(a) - new Date(b)
  //       );

  //       const netProfitData = dailyDataKeys.map(date => dailyNetGainLoss[date] || 0);

  //       const formattedChartData = {
  //         labels: dailyDataKeys,
  //         datasets: [
  //           {
  //             label: "Net Profit (%)",
  //             data: netProfitData,
  //             backgroundColor: netProfitData.map(value =>
  //               value >= 0 ? "rgba(15, 230, 122, 0.6)" : "rgba(236, 34, 19, 0.6)"
  //             ),
  //             borderColor: netProfitData.map(value =>
  //               value >= 0 ? "blue" : "red"
  //             ),
  //             borderWidth: 1,
  //           },
  //         ],
  //       };

  //       setChartData1(formattedChartData);

  //       // 🔹 Doughnut chart calculation (matching card calculations)
  //       let totalProfitPercent = 0;
  //       let totalLossPercent = 0;
  //       let netProfitPercent = 0;

  //       signalList.forEach(signal => {
  //         const percentValue = parseFloat(signal?.netGainLossPercent?.replace("%", "")) || 0;
  //         if (percentValue > 0) totalProfitPercent += percentValue;
  //         if (percentValue < 0) totalLossPercent += percentValue;
  //         netProfitPercent += percentValue;
  //       });

  //       const doughnutChartData = {
  //         labels: ["Total Signals", "Profitable Calls", "Loss Calls", "Total Profit (%)", "Total Loss (%)", "Net Profit/Loss (%)"],
  //         datasets: [
  //           {
  //             data: [
  //               response?.data?.totalSignals || 0,
  //               response?.data?.profitableCalls || 0,
  //               response?.data?.lossCalls || 0,
  //               totalProfitPercent.toFixed(2),
  //               totalLossPercent.toFixed(2),
  //               netProfitPercent.toFixed(2),
  //             ],
  //             backgroundColor: ["#36A2EB", "#81ff85ff", "#FF6384", "#0ada3eff", "#FF4444", "#0a5f30ff"],
  //             hoverBackgroundColor: ["#36A2EB", "#81ff85ff", "#FF6384", "#0ada3eff", "#FF4444", "#0a5f30ff"],
  //           },
  //         ],
  //       };

  //       setDoughnutData1(doughnutChartData);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // const getCashpastdata = async () => {
  //   try {
  //     const response = await getpastperformaceCashdata(
  //       { id: "66d2c3bebf7e6dc53ed07626" },
  //       token
  //     );

  //     if (response?.status) {
  //       const allDurations = response.data;

  //       // 🔹 1 Month Data
  //       const oneMonthData = allDurations["1_month"];
  //       const monthKey = Object.keys(oneMonthData?.months || {})[0];
  //       const monthData = oneMonthData?.months?.[monthKey] || {};
  //       const oneMonthPercent = monthData?.netProfitPercentage ?? 0;
  //       setOneMonth(oneMonthPercent);

  //       // 🔹 Last Duration
  //       const durationKeys = Object.keys(allDurations);
  //       const lastKey = durationKeys[durationKeys.length - 1] || "";
  //       const lastDuration = allDurations[lastKey];
  //       const lastNetProfitPercentage = lastDuration?.netProfitPercentageaverall ?? 0;
  //       setFutureAvgProfit(lastNetProfitPercentage);

  //       // 🔹 Month-wise data
  //       const months = lastDuration?.months || {};
  //       const monthWisePercentage = {};
  //       const monthWiseProfitLoss = {};

  //       Object.keys(months).forEach((month) => {
  //         const [year, m] = month.split("-");
  //         const monthKey = `${year}-${m.padStart(2, "0")}`;
  //         monthWisePercentage[monthKey] = months[month]?.netProfitPercentage ?? 0;
  //         monthWiseProfitLoss[monthKey] = {
  //           totalProfit: months[month]?.totalProfit ?? 0,
  //           totalLoss: months[month]?.totalLoss ?? 0,
  //         };
  //       });

  //       // 🔹 Sort months
  //       const sortedMonths = Object.keys(monthWisePercentage).sort((a, b) => {
  //         const [yearA, monthA] = a.split("-").map(Number);
  //         const [yearB, monthB] = b.split("-").map(Number);
  //         return yearA - yearB || monthA - monthB;
  //       });

  //       // 🔹 Separate Profit and Loss Data
  //       const profitData = [];
  //       const lossData = [];
  //       const tooltipData = [];

  //       sortedMonths.forEach((month) => {
  //         let value = monthWisePercentage[month] ?? 0;
  //         if (value > 0 && value < 0.5) value = 0.5;

  //         if (value >= 0) {
  //           profitData.push(value);
  //           lossData.push(null); // null = no bar for loss dataset
  //         } else {
  //           profitData.push(null); // null = no bar for profit dataset
  //           lossData.push(value);
  //         }

  //         tooltipData.push(monthWiseProfitLoss[month]);
  //       });

  //       // 🔹 Set Chart Data with TWO DATASETS
  //       setCashChartData({
  //         labels: sortedMonths.map((m) => {
  //           const [year, month] = m.split("-");
  //           return new Date(year, month - 1).toLocaleString("default", {
  //             month: "short",
  //             year: "2-digit",
  //           });
  //         }),
  //         datasets: [
  //           {
  //             label: "Profit (%)",
  //             data: profitData,
  //             backgroundColor: "rgba(15, 230, 122, 0.8)",
  //             borderColor: "rgba(15, 230, 122, 1)",
  //             borderWidth: 1,
  //             tooltipData: tooltipData,
  //             allMonths: sortedMonths,
  //             monthWisePercentage: monthWisePercentage,
  //             monthWiseProfitLoss: monthWiseProfitLoss,
  //           },
  //           {
  //             label: "Loss (%)",
  //             data: lossData,
  //             backgroundColor: "rgba(236, 34, 19, 0.8)",
  //             borderColor: "rgba(236, 34, 19, 1)",
  //             borderWidth: 1,
  //             tooltipData: tooltipData,
  //             allMonths: sortedMonths,
  //             monthWisePercentage: monthWisePercentage,
  //             monthWiseProfitLoss: monthWiseProfitLoss,
  //           },
  //         ],
  //         options: {
  //           responsive: true,
  //           plugins: {
  //             legend: {
  //               display: true,
  //               position: 'top',
  //               labels: {
  //                 color: '#ffffff',
  //                 font: {
  //                   size: 13,
  //                   weight: '600'
  //                 },
  //                 padding: 15,
  //                 usePointStyle: true,
  //                 pointStyle: 'rect',
  //                 boxWidth: 30,
  //                 boxHeight: 15,
  //               },
  //               onClick: function (e, legendItem, legend) {
  //                 const chart = legend.chart;
  //                 const datasetIndex = legendItem.datasetIndex;
  //                 const dataset = chart.data.datasets[0]; // Get data from first dataset
  //                 const allMonths = dataset.allMonths;
  //                 const monthWisePercentage = dataset.monthWisePercentage;
  //                 const monthWiseProfitLoss = dataset.monthWiseProfitLoss;

  //                 let filteredMonths;

  //                 if (datasetIndex === 0) { // Profit clicked
  //                   filteredMonths = allMonths.filter(m => monthWisePercentage[m] >= 0);
  //                 } else { // Loss clicked
  //                   filteredMonths = allMonths.filter(m => monthWisePercentage[m] < 0);
  //                 }

  //                 if (filteredMonths.length === 0) {
  //                   filteredMonths = allMonths;
  //                 }

  //                 // Rebuild data for both datasets
  //                 const newProfitData = [];
  //                 const newLossData = [];
  //                 const newTooltipData = [];

  //                 filteredMonths.forEach((month) => {
  //                   let value = monthWisePercentage[month] ?? 0;
  //                   if (value > 0 && value < 0.5) value = 0.5;

  //                   if (value >= 0) {
  //                     newProfitData.push(value);
  //                     newLossData.push(null);
  //                   } else {
  //                     newProfitData.push(null);
  //                     newLossData.push(value);
  //                   }

  //                   newTooltipData.push(monthWiseProfitLoss[month]);
  //                 });

  //                 chart.data.labels = filteredMonths.map((m) => {
  //                   const [year, month] = m.split("-");
  //                   return new Date(year, month - 1).toLocaleString("default", {
  //                     month: "short",
  //                     year: "2-digit",
  //                   });
  //                 });

  //                 chart.data.datasets[0].data = newProfitData;
  //                 chart.data.datasets[1].data = newLossData;
  //                 chart.data.datasets[0].tooltipData = newTooltipData;
  //                 chart.data.datasets[1].tooltipData = newTooltipData;

  //                 const allValues = [...newProfitData, ...newLossData].filter(v => v !== null);
  //                 chart.options.scales.y.min = Math.min(...allValues, 0) * 1.2;
  //                 chart.options.scales.y.max = Math.max(...allValues, 0) * 1.2;

  //                 chart.update();
  //               }
  //             },
  //             tooltip: {
  //               callbacks: {
  //                 label: function (context) {
  //                   const tooltipData = context.dataset.tooltipData[context.dataIndex];
  //                   const { totalProfit, totalLoss } = tooltipData || {};
  //                   const value = context.raw?.toFixed(2) || '0.00';
  //                   return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}%`;
  //                 },
  //               },
  //             },
  //           },
  //           scales: {
  //             y: {
  //               ticks: {
  //                 callback: function (value) {
  //                   return value.toFixed(2) + "%";
  //                 },
  //                 color: '#ffffff'
  //               },
  //               grid: {
  //                 color: 'rgba(255, 255, 255, 0.1)'
  //               },
  //               min: Math.min(...profitData.filter(v => v !== null), ...lossData.filter(v => v !== null), 0) * 1.2,
  //               max: Math.max(...profitData.filter(v => v !== null), ...lossData.filter(v => v !== null), 0) * 1.2,
  //             },
  //             x: {
  //               ticks: {
  //                 color: '#ffffff'
  //               },
  //               grid: {
  //                 color: 'rgba(255, 255, 255, 0.1)'
  //               }
  //             }
  //           },
  //         },
  //       });

  //       setCashPastdata([...profitData, ...lossData].filter(v => v !== null));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Cash data:", error);
  //   }
  // };

  // Comented by shakti

  // const getCashpastdata = async () => {
  //   try {
  //     const response = await getpastperformaceCashdata(
  //       { id: "66d2c3bebf7e6dc53ed07626" },
  //       token
  //     );

  //     if (response?.status) {
  //       const allDurations = response.data;

  //       // 🔹 1 Month Data
  //       const oneMonthData = allDurations["1_month"];
  //       const monthKey = Object.keys(oneMonthData?.months || {})[0];
  //       const monthData = oneMonthData?.months?.[monthKey] || {};
  //       const oneMonthPercent = monthData?.netProfitPercentage ?? 0;
  //       setOneMonth(oneMonthPercent);

  //       // 🔹 Last Duration
  //       const durationKeys = Object.keys(allDurations);
  //       const lastKey = durationKeys[durationKeys.length - 1] || "";
  //       const lastDuration = allDurations[lastKey];
  //       const lastNetProfitPercentage = lastDuration?.netProfitPercentageaverall ?? 0;
  //       setFutureAvgProfit(lastNetProfitPercentage);

  //       // 🔹 Month-wise data
  //       const months = lastDuration?.months || {};
  //       const monthWisePercentage = {};
  //       const monthWiseProfitLoss = {};

  //       Object.keys(months).forEach((month) => {
  //         const [year, m] = month.split("-");
  //         const monthKey = `${year}-${m.padStart(2, "0")}`;
  //         monthWisePercentage[monthKey] = months[month]?.netProfitPercentage ?? 0;
  //         monthWiseProfitLoss[monthKey] = {
  //           totalProfit: months[month]?.totalProfit ?? 0,
  //           totalLoss: months[month]?.totalLoss ?? 0,
  //         };
  //       });

  //       // 🔹 Sort months
  //       const sortedMonths = Object.keys(monthWisePercentage).sort((a, b) => {
  //         const [yearA, monthA] = a.split("-").map(Number);
  //         const [yearB, monthB] = b.split("-").map(Number);
  //         return yearA - yearB || monthA - monthB;
  //       });

  //       // 🔹 Separate Profit and Loss Data
  //       const profitData = [];
  //       const lossData = [];
  //       const tooltipData = [];

  //       sortedMonths.forEach((month) => {
  //         let value = monthWisePercentage[month] ?? 0;
  //         if (value > 0 && value < 0.5) value = 0.5;

  //         if (value >= 0) {
  //           profitData.push(value);
  //           lossData.push(null);
  //         } else {
  //           profitData.push(null);
  //           lossData.push(value);
  //         }

  //         tooltipData.push(monthWiseProfitLoss[month]);
  //       });

  //       // 🔹 Set Chart Data with TWO DATASETS
  //       setCashChartData({
  //         labels: sortedMonths.map((m) => {
  //           const [year, month] = m.split("-");
  //           return new Date(year, month - 1).toLocaleString("default", {
  //             month: "short",
  //             year: "2-digit",
  //           });
  //         }),
  //         datasets: [
  //           {
  //             label: "Profit (%)",
  //             data: profitData,
  //             backgroundColor: "rgba(15, 230, 122, 0.8)",
  //             borderColor: "rgba(15, 230, 122, 1)",
  //             borderWidth: 1,
  //             barPercentage: 0.6,
  //             categoryPercentage: 0.7,
  //             tooltipData: tooltipData,
  //             allMonths: sortedMonths,
  //             monthWisePercentage: monthWisePercentage,
  //             monthWiseProfitLoss: monthWiseProfitLoss,
  //           },
  //           {
  //             label: "Loss (%)",
  //             data: lossData,
  //             backgroundColor: "rgba(236, 34, 19, 0.8)",
  //             borderColor: "rgba(236, 34, 19, 1)",
  //             borderWidth: 1,
  //             barPercentage: 0.6,
  //             categoryPercentage: 0.7,
  //             tooltipData: tooltipData,
  //             allMonths: sortedMonths,
  //             monthWisePercentage: monthWisePercentage,
  //             monthWiseProfitLoss: monthWiseProfitLoss,
  //           },
  //         ],
  //         options: {
  //           responsive: true,
  //           plugins: {
  //             legend: {
  //               display: true,
  //               position: 'top',
  //               labels: {
  //                 color: '#ffffff',
  //                 font: { size: 13, weight: '600' },
  //                 padding: 15,
  //                 usePointStyle: true,
  //                 pointStyle: 'rect',
  //                 boxWidth: 30,
  //                 boxHeight: 15,
  //               },
  //               onClick: function (e, legendItem, legend) {
  //                 const chart = legend.chart;
  //                 const datasetIndex = legendItem.datasetIndex;
  //                 const dataset = chart.data.datasets[0];
  //                 const allMonths = dataset.allMonths;
  //                 const monthWisePercentage = dataset.monthWisePercentage;
  //                 const monthWiseProfitLoss = dataset.monthWiseProfitLoss;

  //                 let filteredMonths;
  //                 if (datasetIndex === 0) {
  //                   filteredMonths = allMonths.filter(m => monthWisePercentage[m] >= 0);
  //                 } else {
  //                   filteredMonths = allMonths.filter(m => monthWisePercentage[m] < 0);
  //                 }
  //                 if (filteredMonths.length === 0) filteredMonths = allMonths;

  //                 const newProfitData = [];
  //                 const newLossData = [];
  //                 const newTooltipData = [];

  //                 filteredMonths.forEach((month) => {
  //                   let value = monthWisePercentage[month] ?? 0;
  //                   if (value > 0 && value < 0.5) value = 0.5;

  //                   if (value >= 0) {
  //                     newProfitData.push(value);
  //                     newLossData.push(null);
  //                   } else {
  //                     newProfitData.push(null);
  //                     newLossData.push(value);
  //                   }

  //                   newTooltipData.push(monthWiseProfitLoss[month]);
  //                 });

  //                 chart.data.labels = filteredMonths.map((m) => {
  //                   const [year, month] = m.split("-");
  //                   return new Date(year, month - 1).toLocaleString("default", {
  //                     month: "short",
  //                     year: "2-digit",
  //                   });
  //                 });

  //                 chart.data.datasets[0].data = newProfitData;
  //                 chart.data.datasets[1].data = newLossData;
  //                 chart.data.datasets[0].tooltipData = newTooltipData;
  //                 chart.data.datasets[1].tooltipData = newTooltipData;

  //                 const allValues = [...newProfitData, ...newLossData].filter(v => v !== null);
  //                 chart.options.scales.y.min = Math.min(...allValues, 0) * 1.2;
  //                 chart.options.scales.y.max = Math.max(...allValues, 0) * 1.2;

  //                 chart.update();
  //               }
  //             },
  //             tooltip: {
  //               callbacks: {
  //                 label: function (context) {
  //                   const tooltipData = context.dataset.tooltipData[context.dataIndex];
  //                   const { totalProfit, totalLoss } = tooltipData || {};
  //                   const value = context.raw?.toFixed(2) || '0.00';
  //                   return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}%`;
  //                 },
  //               },
  //             },
  //           },
  //           scales: {
  //             x: {
  //               offset: true, // ← fix bar alignment with label
  //               ticks: { color: '#ffffff' },
  //               grid: { color: 'rgba(255, 255, 255, 0.1)' },
  //               stacked: false,
  //             },
  //             y: {
  //               ticks: {
  //                 callback: function (value) { return value.toFixed(2) + "%"; },
  //                 color: '#ffffff'
  //               },
  //               grid: { color: 'rgba(255, 255, 255, 0.1)' },
  //               min: Math.min(...profitData.filter(v => v !== null), ...lossData.filter(v => v !== null), 0) * 1.2,
  //               max: Math.max(...profitData.filter(v => v !== null), ...lossData.filter(v => v !== null), 0) * 1.2,
  //             }
  //           },
  //         },
  //       });

  //       setCashPastdata([...profitData, ...lossData].filter(v => v !== null));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Cash data:", error);
  //   }
  // };

  // Comented by shakti

  const getCashpastdata = async () => {
    try {
      const response = await getpastperformaceCashdata(
        { id: "66d2c3bebf7e6dc53ed07626" },
        token
      );

      if (response?.status) {
        const allDurations = response.data;

        // 🔹 1 Month Data
        const oneMonthData = allDurations["1_month"];
        const monthKey = Object.keys(oneMonthData?.months || {})[0];
        const monthData = oneMonthData?.months?.[monthKey] || {};
        const oneMonthPercent = monthData?.netProfitPercentage ?? 0;
        setOneMonth(oneMonthPercent);

        // 🔹 Last Duration
        const durationKeys = Object.keys(allDurations);
        const lastKey = durationKeys[durationKeys.length - 1] || "";
        const lastDuration = allDurations[lastKey];
        const lastNetProfitPercentage =
          lastDuration?.netProfitPercentageaverall ?? 0;
        setFutureAvgProfit(lastNetProfitPercentage);

        // 🔹 Month-wise data
        const months = lastDuration?.months || {};
        const monthWisePercentage = {};
        const monthWiseProfitLoss = {};

        Object.keys(months).forEach((month) => {
          const [year, m] = month.split("-");
          const monthKey = `${year}-${m.padStart(2, "0")}`;
          monthWisePercentage[monthKey] =
            months[month]?.netProfitPercentage ?? 0;
          monthWiseProfitLoss[monthKey] = {
            totalProfit: months[month]?.totalProfit ?? 0,
            totalLoss: months[month]?.totalLoss ?? 0,
          };
        });

        // 🔹 Sort months
        const sortedMonths = Object.keys(monthWisePercentage).sort((a, b) => {
          const [yearA, monthA] = a.split("-").map(Number);
          const [yearB, monthB] = b.split("-").map(Number);
          return yearA - yearB || monthA - monthB;
        });

        // 🔹 Separate Profit and Loss Data
        const profitData = [];
        const lossData = [];
        const tooltipData = [];

        sortedMonths.forEach((month) => {
          let value = monthWisePercentage[month] ?? 0;
          if (value > 0 && value < 0.5) value = 0.5;

          if (value >= 0) {
            profitData.push(value);
            lossData.push(null);
          } else {
            profitData.push(null);
            lossData.push(value);
          }

          tooltipData.push(monthWiseProfitLoss[month]);
        });

        // 🔹 Dynamic bar width based on data length
        const dataLength = sortedMonths.length;
        let barPercentage = 0.6;
        let categoryPercentage = 0.7;

        if (dataLength <= 3) {
          barPercentage = 0.3;
          categoryPercentage = 0.4;
        } else if (dataLength <= 6) {
          barPercentage = 0.5;
          categoryPercentage = 0.6;
        }

        setCashChartData({
          labels: sortedMonths.map((m) => {
            const [year, month] = m.split("-");
            return new Date(year, month - 1).toLocaleString("default", {
              month: "short",
              year: "2-digit",
            });
          }),
          datasets: [
            {
              label: "Profit/Loss (%)",
              data: sortedMonths.map((m) => monthWisePercentage[m]),
              backgroundColor: sortedMonths.map(
                (m) =>
                  monthWisePercentage[m] >= 0
                    ? "rgba(15, 230, 122, 0.8)" // profit green
                    : "rgba(236, 34, 19, 0.8)" // loss red
              ),
              borderColor: sortedMonths.map((m) =>
                monthWisePercentage[m] >= 0
                  ? "rgba(15, 230, 122, 1)"
                  : "rgba(236, 34, 19, 1)"
              ),
              borderWidth: 1,
              borderRadius: 6,
              barThickness: "flex",
              maxBarThickness: 45,
              minBarLength: 3,
              tooltipData,
            },
          ],
          options: {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              legend: {
                display: true,
                position: "top",
                labels: {
                  color: "#ffffff",
                  font: { size: 13, weight: "600" },
                  padding: 15,
                  usePointStyle: true,
                  pointStyle: "rect",
                  boxWidth: 30,
                  boxHeight: 15,
                  generateLabels: function () {
                    return [
                      {
                        text: "Profit (%)",
                        fillStyle: "rgba(15, 230, 122, 0.8)",
                        strokeStyle: "rgba(15, 230, 122, 1)",
                      },
                      {
                        text: "Loss (%)",
                        fillStyle: "rgba(236, 34, 19, 0.8)",
                        strokeStyle: "rgba(236, 34, 19, 1)",
                      },
                    ];
                  },
                },
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const tooltipData =
                      context.dataset.tooltipData[context.dataIndex];
                    const { totalProfit, totalLoss } = tooltipData || {};
                    const value = context.raw?.toFixed(2) || "0.00";
                    return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}%`;
                  },
                },
              },
            },
            scales: {
              x: {
                ticks: {
                  color: "#ffffff",
                  maxRotation: 45,
                  minRotation: 0,
                },
                grid: {
                  display: false,
                  color: "rgba(255,255,255,0.1)",
                },
              },
              y: {
                ticks: {
                  callback: (value) => value.toFixed(2) + "%",
                  color: "#ffffff",
                },
                grid: {
                  color: "rgba(255,255,255,0.1)",
                },
                min: Math.min(...Object.values(monthWisePercentage), 0) * 1.2,
                max: Math.max(...Object.values(monthWisePercentage), 0) * 1.2,
              },
            },
          },
        });

        // setCashChartData({
        //   labels: sortedMonths.map((m) => {
        //     const [year, month] = m.split("-");
        //     return new Date(year, month - 1).toLocaleString("default", {
        //       month: "short",
        //       year: "2-digit",
        //     });
        //   }),
        //   datasets: [
        //     {
        //       label: "Profit (%)",
        //       data: profitData,
        //       backgroundColor: "rgba(15, 230, 122, 0.8)",
        //       borderColor: "rgba(15, 230, 122, 1)",
        //       borderWidth: 1,
        //       grouped: true,
        //       barThickness: "flex", // dynamic width
        //       maxBarThickness: 40, // limit width for few bars
        //       minBarLength: 3,
        //       tooltipData,
        //       allMonths: sortedMonths,
        //       monthWisePercentage,
        //       monthWiseProfitLoss,
        //     },
        //     {
        //       label: "Loss (%)",
        //       data: lossData,
        //       backgroundColor: "rgba(236, 34, 19, 0.8)",
        //       borderColor: "rgba(236, 34, 19, 1)",
        //       borderWidth: 1,
        //       grouped: true,
        //       barThickness: "flex",
        //       maxBarThickness: 40,
        //       minBarLength: 3,
        //       tooltipData,
        //       allMonths: sortedMonths,
        //       monthWisePercentage,
        //       monthWiseProfitLoss,
        //     },
        //   ],

        //   options: {
        //     responsive: true,
        //     maintainAspectRatio: true,
        //     plugins: {
        //       legend: {
        //         display: true,
        //         position: "top",
        //         labels: {
        //           color: "#ffffff",
        //           font: { size: 13, weight: "600" },
        //           padding: 15,
        //           usePointStyle: true,
        //           pointStyle: "rect",
        //           boxWidth: 30,
        //           boxHeight: 15,
        //         },
        //         onClick: function (e, legendItem, legend) {
        //           const chart = legend.chart;
        //           const datasetIndex = legendItem.datasetIndex;
        //           const dataset = chart.data.datasets[0];
        //           const allMonths = dataset.allMonths;
        //           const monthWisePercentage = dataset.monthWisePercentage;
        //           const monthWiseProfitLoss = dataset.monthWiseProfitLoss;

        //           let filteredMonths;
        //           if (datasetIndex === 0) {
        //             filteredMonths = allMonths.filter(
        //               (m) => monthWisePercentage[m] >= 0
        //             );
        //           } else {
        //             filteredMonths = allMonths.filter(
        //               (m) => monthWisePercentage[m] < 0
        //             );
        //           }
        //           if (filteredMonths.length === 0) filteredMonths = allMonths;

        //           const newProfitData = [];
        //           const newLossData = [];
        //           const newTooltipData = [];

        //           filteredMonths.forEach((month) => {
        //             let value = monthWisePercentage[month] ?? 0;
        //             if (value > 0 && value < 0.5) value = 0.5;

        //             if (value >= 0) {
        //               newProfitData.push(value);
        //               newLossData.push(null);
        //             } else {
        //               newProfitData.push(null);
        //               newLossData.push(value);
        //             }

        //             newTooltipData.push(monthWiseProfitLoss[month]);
        //           });

        //           chart.data.labels = filteredMonths.map((m) => {
        //             const [year, month] = m.split("-");
        //             return new Date(year, month - 1).toLocaleString("default", {
        //               month: "short",
        //               year: "2-digit",
        //             });
        //           });

        //           chart.data.datasets[0].data = newProfitData;
        //           chart.data.datasets[1].data = newLossData;
        //           chart.data.datasets[0].tooltipData = newTooltipData;
        //           chart.data.datasets[1].tooltipData = newTooltipData;

        //           const allValues = [...newProfitData, ...newLossData].filter(
        //             (v) => v !== null
        //           );
        //           chart.options.scales.y.min = Math.min(...allValues, 0) * 1.2;
        //           chart.options.scales.y.max = Math.max(...allValues, 0) * 1.2;

        //           chart.update();
        //         },
        //       },
        //       tooltip: {
        //         callbacks: {
        //           label: function (context) {
        //             const tooltipData =
        //               context.dataset.tooltipData[context.dataIndex];
        //             const { totalProfit, totalLoss } = tooltipData || {};
        //             const value = context.raw?.toFixed(2) || "0.00";
        //             return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}%`;
        //           },
        //         },
        //       },
        //     },
        //     scales: {
        //       x: {
        //         ticks: {
        //           color: "#ffffff",
        //           maxRotation: 45,
        //           minRotation: 0,
        //         },
        //         grid: {
        //           display: false,
        //           color: "rgba(255, 255, 255, 0.1)",
        //         },
        //       },
        //       y: {
        //         ticks: {
        //           callback: function (value) {
        //             return value.toFixed(2) + "%";
        //           },
        //           color: "#ffffff",
        //         },
        //         grid: {
        //           color: "rgba(255, 255, 255, 0.1)",
        //         },
        //         min:
        //           Math.min(
        //             ...profitData.filter((v) => v !== null),
        //             ...lossData.filter((v) => v !== null),
        //             0
        //           ) * 1.2,
        //         max:
        //           Math.max(
        //             ...profitData.filter((v) => v !== null),
        //             ...lossData.filter((v) => v !== null),
        //             0
        //           ) * 1.2,
        //       },
        //     },
        //   },
        // });

        setCashPastdata([...profitData, ...lossData].filter((v) => v !== null));
      }
    } catch (error) {
      console.error("Error fetching Cash data:", error);
    }
  };

  const getPastPerformanceData = async () => {
    try {
      const data = { id: "66d2c3bebf7e6dc53ed07626", month, year };
      const response = await getpastperformacebymonth(data, token);

      if (response?.status) {
        setDailydata(response?.data);

        const signalList = response?.data?.signalList || [];

        // 🔹 Group signals by entryDate and sum netGainLossPercent for each day
        const dailyNetGainLoss = signalList.reduce((acc, signal) => {
          const dateObj = new Date(signal.entryDate);
          const date = `${dateObj.getDate()}-${
            dateObj.getMonth() + 1
          }-${dateObj.getFullYear()}`;

          const percent =
            parseFloat(signal.netGainLossPercent?.replace("%", "")) || 0;

          if (!acc[date]) acc[date] = 0;
          acc[date] += percent;

          return acc;
        }, {});

        // Prepare chart data (Bar/Line chart)
        const dailyDataKeys = Object.keys(response?.data?.dailyData || {}).sort(
          (a, b) => new Date(a) - new Date(b)
        );

        const netProfitData = dailyDataKeys.map(
          (date) => dailyNetGainLoss[date] || 0
        );

        const formattedChartData = {
          labels: dailyDataKeys,
          datasets: [
            {
              label: "",
              data: netProfitData,
              backgroundColor: netProfitData.map((value) =>
                value >= 0
                  ? "rgba(15, 230, 122, 0.6)"
                  : "rgba(236, 34, 19, 0.6)"
              ),
              borderColor: netProfitData.map((value) =>
                value >= 0 ? "blue" : "red"
              ),
              borderWidth: 1,
            },
          ],
        };

        setChartData1(formattedChartData);

        let totalProfitPercent = 0;
        let totalLossPercent = 0;
        let netProfitPercent = 0;

        signalList.forEach((signal) => {
          const percentValue =
            parseFloat(signal?.netGainLossPercent?.replace("%", "")) || 0;
          if (percentValue > 0) totalProfitPercent += percentValue;
          if (percentValue < 0) totalLossPercent += percentValue;
          netProfitPercent += percentValue;
        });

        const rawDoughnutData = [
          response?.data?.totalSignals || 0,
          response?.data?.profitableCalls || 0,
          response?.data?.lossCalls || 0,
          totalProfitPercent,
          totalLossPercent,
          netProfitPercent,
        ];

        // 🔹 Scale small values for visibility
        const scaledDoughnutData = rawDoughnutData.map((val) =>
          val === 0 ? 1 : Math.log(Math.abs(val) + 1)
        );

        const doughnutChartData = {
          labels: [
            "Total Calls",
            "Profitable Calls",
            "Loss Calls",
            "Total Profit (%)",
            "Total Loss (%)",
            "Net Profit/Loss (%)",
          ],
          datasets: [
            {
              data: scaledDoughnutData,
              originalData: rawDoughnutData,
              backgroundColor: [
                "#36A2EB",
                "#81ff85ff",
                "#FF6384",
                "#0ada3eff",
                "#FF4444",
                "#0a5f30ff",
              ],
              hoverBackgroundColor: [
                "#36A2EB",
                "#81ff85ff",
                "#FF6384",
                "#0ada3eff",
                "#FF4444",
                "#0a5f30ff",
              ],
            },
          ],
        };

        const doughnutOptions = {
          plugins: {
            tooltip: {
              callbacks: {
                label: function (context) {
                  const originalValue =
                    context.dataset.originalData[context.dataIndex];
                  if (originalValue === 0) return "";
                  return `${context.label}: ${Number(originalValue).toFixed(
                    2
                  )}`;
                },
              },
            },
          },
        };

        setDoughnutData1(doughnutChartData);
        setDoughnutOptions(doughnutOptions);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getPastPerformanceData();
  }, [month, year]);

  // const changeMonth = (direction) => {
  //   let currentIndex = months.findIndex((m) => m.value === month);
  //   if (direction === "prev") {
  //     currentIndex = currentIndex > 0 ? currentIndex - 1 : 11;
  //   } else {
  //     currentIndex = currentIndex < 11 ? currentIndex + 1 : 0;
  //   }
  //   setMonth(months[currentIndex].value);
  //   if (currentIndex === 11 && direction === "next") {
  //     setYear((prevYear) => (parseInt(prevYear) + 1).toString());
  //   } else if (currentIndex === 0 && direction === "prev") {
  //     setYear((prevYear) => (parseInt(prevYear) - 1).toString());
  //   }
  // };

  // 👇 Your corrected month navigation logic
  const changeMonth = (direction) => {
    const currentIndex = months.findIndex((m) => m.value === month);
    let newIndex = currentIndex;
    let newYear = parseInt(year);

    if (direction === "next") {
      if (currentIndex === 11) {
        // December → January of next year
        newIndex = 0;
        newYear += 1;
      } else {
        newIndex = currentIndex + 1;
      }
    } else if (direction === "prev") {
      if (currentIndex === 0) {
        // January → December of previous year
        newIndex = 11;
        newYear -= 1;
      } else {
        newIndex = currentIndex - 1;
      }
    }

    // Dono state updates ek saath karo
    const newMonth = months[newIndex].value;
    setMonth(newMonth);
    setYear(newYear.toString());
  };

  const handleViewClick = (description) => {
    setDescription({ description });
  };

  const handleDownload = (row) => {
    const url = row.report_full_path;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = [
    {
      name: "Stocks Name",
      selector: (row) => row?.stockName,
      sortable: true,
      width: "300px",
    },
    {
      name: "Entry Type",
      selector: (row) => row?.entryType,
      sortable: true,
      width: "200px",
    },
    {
      name: "Entry Date",
      selector: (row) => fDateTime(row.entryDate),
      sortable: true,
      width: "200px",
    },
    {
      name: "Entry Price",
      selector: (row) => row?.entryPrice,
      cell: (row) => (
        <div>
          <IndianRupee size={14} />
          {(row?.entryPrice).toFixed(2)}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Exit Date",
      selector: (row) => fDateTime(row.exitDate),
      sortable: true,
      width: "200px",
    },
    {
      name: "Exit Price",
      selector: (row) => row?.exitPrice,
      cell: (row) => (
        <div>
          <IndianRupee size={14} />
          {(row?.exitPrice).toFixed(2)}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Net Gain/Loss",
      selector: (row) => {
        const entryPrice = row?.entryPrice || 0;
        const exitPrice = row?.exitPrice || 0;
        const profitLoss = exitPrice - entryPrice;
        return entryPrice > 0 ? (profitLoss / entryPrice) * 100 : 0;
      },
      cell: (row) => {
        const entryPrice = row?.entryPrice || 0;
        const exitPrice = row?.exitPrice || 0;
        const profitLoss = exitPrice - entryPrice;
        const percentage =
          entryPrice > 0
            ? ((profitLoss / entryPrice) * 100).toFixed(2)
            : "0.00";
        return percentage + "%";
      },
      sortable: true,
      width: "200px",
      conditionalCellStyles: [
        {
          when: (row) => {
            const entryPrice = row?.entryPrice || 0;
            const exitPrice = row?.exitPrice || 0;
            return exitPrice - entryPrice < 0;
          },
          style: { color: "red", fontWeight: "bold" },
        },
        {
          when: (row) => {
            const entryPrice = row?.entryPrice || 0;
            const exitPrice = row?.exitPrice || 0;
            return exitPrice - entryPrice >= 0;
          },
          style: { color: "green", fontWeight: "bold" },
        },
      ],
    },
    {
      name: "Description",
      cell: (row) => (
        <div>
          <Tooltip placement="top" overlay="View">
            <Eye
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleViewClick([row.description]);
                setShowModal(true);
              }}
            />
          </Tooltip>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Report",
      cell: (row) => (
        <>
          {row.report_full_path ? (
            <div className="d-flex">
              <Link className="btn px-2" onClick={() => handleDownload(row)}>
                <Tooltip placement="top" overlay="Download">
                  <ArrowDownToLine />
                </Tooltip>
              </Link>
            </div>
          ) : (
            "-"
          )}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "200px",
    },
  ];
  const getPrevMonthYear = () => {
    const currentIndex = months.findIndex((m) => m.value === month);
    if (currentIndex === 0) {
      return { month: months[11].name, year: parseInt(year) - 1 };
    } else {
      return { month: months[currentIndex - 1].name, year: parseInt(year) };
    }
  };

  const getNextMonthYear = () => {
    const currentIndex = months.findIndex((m) => m.value === month);
    if (currentIndex === 11) {
      return { month: months[0].name, year: parseInt(year) + 1 };
    } else {
      return { month: months[currentIndex + 1].name, year: parseInt(year) };
    }
  };
  return (
    <Content
      Page_title="Cash"
      button_status={false}
      backbutton_status={false}
      backForword={true}
    >
      <div className="page-content">
        <div className="row">
          <div className="col-md-3 mb-3">
            <div className="card">
              <ul className="list-group list-group-flush mt-0">
                <li className="list-group-item d-flex justify-content-between align-items-center headingfont">
                  1 Month Average
                </li>
                <li className="list-group-item d-flex align-items-center fs-5 fw-bold">
                  <span className="badge btn-primary badgespan me-1">
                    <i className="bx bx-percent fs-5 text-dark"></i>
                  </span>{" "}
                  <h4
                    className={`${
                      oneMonth < 0 ? "text-danger" : "text-success"
                    }`}
                  >
                    {oneMonth.toFixed(2)}
                    <span>%</span>
                  </h4>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <ul className="list-group list-group-flush mt-0">
                <li className="list-group-item d-flex justify-content-between align-items-center headingfont">
                  3 Month Average<span></span>
                </li>
                <li className="list-group-item d-flex align-items-center fs-5 fw-bold">
                  <span className="badge btn-primary badgespan me-1">
                    <i className="bx bx-percent fs-5 text-dark"></i>
                  </span>{" "}
                  <h4
                    className={`${
                      futureAvgProfit / 3 < 0 ? "text-danger" : "text-success"
                    }`}
                  >
                    {(futureAvgProfit / 3).toFixed(2)}
                    <span>%</span>
                  </h4>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <ul className="list-group list-group-flush mt-0">
                <li className="list-group-item d-flex justify-content-between align-items-center headingfont">
                  6 Month Average<span></span>
                </li>
                <li className="list-group-item d-flex align-items-center fs-5 fw-bold">
                  <span className="badge btn-primary badgespan me-1">
                    <i className="bx bx-percent fs-5 text-dark"></i>
                  </span>{" "}
                  <h4
                    className={`${
                      futureAvgProfit / 6 < 0 ? "text-danger" : "text-success"
                    }`}
                  >
                    {(futureAvgProfit / 6).toFixed(2)}
                    <span>%</span>
                  </h4>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <ul className="list-group list-group-flush mt-0">
                <li className="list-group-item d-flex justify-content-between align-items-center headingfont">
                  1 Year Average<span></span>
                </li>
                <li className="list-group-item d-flex align-items-center fs-5 fw-bold">
                  <span className="badge btn-primary badgespan me-1">
                    <i className="bx bx-percent fs-5 text-dark"></i>
                  </span>{" "}
                  <h4
                    className={`${
                      futureAvgProfit / 12 < 0 ? "text-danger" : "text-success"
                    }`}
                  >
                    {(futureAvgProfit / 12).toFixed(2)}
                    <span>%</span>
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                {cashChartData && (
                  <Bar
                    data={cashChartData}
                    options={{
                      responsive: true,
                      plugins: {
                        legend: {
                          display: false, // 🔹 hides the legend box
                        },
                        title: {
                          display: true,
                          text: "Cash Performance (Monthly %)",
                        },
                      },

                      scales: {
                        y: {
                          title: {
                            display: true,
                            text: "Percentage (%)",
                          },
                          ticks: {
                            callback: function (value) {
                              return value + "%";
                            },
                          },
                        },
                      },
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row mt-2 mb-2">
            <div className="col-md-12">
              <div className="alert alert-primary" role="alert">
                {/* <div className="d-md-flex justify-content-between align-items-center">
                  <div>
                    Cash ({months.find((m) => m.value === month)?.name} {year})
                    PERFORMANCE
                  </div>
                  <div className="mt-md-0 mt-3">
                    <button
                      className="btn btn-primary me-2"
                      onClick={() => changeMonth("prev")}
                    >
                      <i className="bx bx-left-arrow-alt"></i>{" "}
                      {
                        months[
                          (months.findIndex((m) => m.value === month) -
                            1 +
                            12) %
                            12
                        ]?.name
                      }{" "}
                      {year}
                    </button>
                    <button className="btn btn-primary">
                      {months.find((m) => m.value === month)?.name} {year}
                    </button>
                    <button
                      className="btn btn-primary ms-2"
                      onClick={() => changeMonth("next")}
                    >
                      {
                        months[
                          (months.findIndex((m) => m.value === month) + 1) % 12
                        ]?.name
                      }{" "}
                      {year} <i className="bx bx-right-arrow-alt"></i>
                    </button>
                  </div>
                </div> */}

                <div className="d-md-flex justify-content-between align-items-center">
                  <div>
                    Cash ({months.find((m) => m.value === month)?.name} {year})
                    PERFORMANCE
                  </div>
                  <div className="mt-md-0 mt-3">
                    {/* Previous Button */}
                    <button
                      className="btn btn-primary me-2"
                      onClick={() => changeMonth("prev")}
                    >
                      <i className="bx bx-left-arrow-alt"></i>{" "}
                      {(() => {
                        const prev = getPrevMonthYear();
                        return `${prev.month} ${prev.year}`;
                      })()}
                    </button>

                    {/* Current Month */}
                    <button className="btn btn-primary">
                      {months.find((m) => m.value === month)?.name} {year}
                    </button>

                    {/* Next Button */}
                    <button
                      className="btn btn-primary ms-2"
                      onClick={() => changeMonth("next")}
                    >
                      {(() => {
                        const next = getNextMonthYear();
                        return `${next.month} ${next.year}`;
                      })()}{" "}
                      <i className="bx bx-right-arrow-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row text-light">
            <div className="col-md-4">
              <div className="card radius-10 overflow-hidden w-100">
                <div className="card-body">
                  <p className="text-light">Cash</p>
                  <h4 className="mb-0 text-light">
                    {months.find((m) => m.value === month)?.name} {year}
                  </h4>
                  <hr />
                  <p className="text-light">Profit - Loss Summary</p>
                  <div className="mt-5">
                    {/* {doughnutData1 ? <Doughnut data={doughnutData1} /> : <p>Loading...</p>} */}
                    {doughnutData1 ? (
                      <Doughnut
                        data={doughnutData1}
                        options={doughnutOptions}
                      />
                    ) : (
                      <p>Loading...</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="card radius-10 overflow-hidden w-100 h-100">
                <div className="card-body">
                  {chartData1 ? (
                    <Bar
                      data={chartData1}
                      options={{
                        responsive: true,
                        plugins: {
                          legend: {
                            display: false,
                          },
                          title: {
                            display: false,
                          },
                          tooltip: {
                            enabled: true,
                          },
                        },
                        scales: {
                          x: {
                            title: {
                              display: true,
                              text: "Dates",
                            },
                          },
                          y: {
                            title: {
                              display: true,
                              text: "Net Profit (%)",
                            },
                            ticks: {
                              callback: (value) => value + "%",
                            },
                          },
                        },
                      }}
                    />
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-4 text-light">
          <div className="d-md-flex gap-3">
            <div className="card-body card">
              <p className="mb-1">
                <strong>Total Calls</strong>
              </p>
              <h6 className="card-title">{dailydata?.totalSignals}</h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Profitable Calls</strong>
              </p>
              <h6 className="card-title">{dailydata?.profitableCalls}</h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Loss Calls</strong>
              </p>
              <h6 className="card-title">{dailydata?.lossCalls}</h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Total Profit (%)</strong>
              </p>
              <h6 className="card-title">
                {(() => {
                  const signalList = dailydata?.signalList || [];

                  let totalNetPercent = 0;

                  signalList.forEach((signal) => {
                    const percentValue =
                      parseFloat(
                        signal?.netGainLossPercent?.replace("%", "")
                      ) || 0;
                    if (percentValue > 0) {
                      totalNetPercent += percentValue;
                    }
                  });

                  return totalNetPercent.toFixed(2);
                })()}
                %
              </h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Total Loss (%)</strong>
              </p>
              <h6 className="card-title">
                {(() => {
                  const signalList = dailydata?.signalList || [];

                  let totalNetPercent = 0;

                  signalList.forEach((signal) => {
                    const percentValue =
                      parseFloat(
                        signal?.netGainLossPercent?.replace("%", "")
                      ) || 0;
                    if (percentValue < 0) {
                      totalNetPercent += percentValue;
                    }
                  });

                  return totalNetPercent.toFixed(2);
                })()}
                %
              </h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Net Profit/Loss (%)</strong>
              </p>
              <h6 className="card-title">
                {(() => {
                  const signalList = dailydata?.signalList || [];

                  let totalNetPercent = 0;

                  signalList.forEach((signal) => {
                    const percentValue =
                      parseFloat(
                        signal?.netGainLossPercent?.replace("%", "")
                      ) || 0;
                    totalNetPercent += percentValue;
                  });

                  return totalNetPercent?.toFixed(2);
                })()}
                %
              </h6>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item rounded-3 border-0 shadow mb-2">
              <h2 className="accordion-header">
                <button
                  className="accordion-button border-bottom collapsed fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h5 className="m-0">
                      Cash ({months.find((m) => m.value === month)?.name} {year}
                      ) RECOMMENDATIONS
                    </h5>
                  </div>
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  <div className="row align-items-center">
                    <div className="col-md-12">
                      <Table
                        columns={columns}
                        data={dailydata?.signalList}
                        pagination
                        striped
                        highlightOnHover
                        dense
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ReusableModal
          show={showModal}
          onClose={() => setShowModal(false)}
          title="Description"
          body={
            <p>{description?.description || "No description available."}</p>
          }
        />
      </div>
    </Content>
  );
};

export default Cash;
